import { gql } from '@apollo/client';
import { SEASON_PARTICIPANT_FIELDS } from '../fragments/season-participant';

const MUTATION = gql`
  mutation CopyMember(
    $divisionId: Int!,
    $isManager: Boolean!,
    $isPlayer: Boolean!,
    $memberId: Int!,
    $organizationId: Int!,
    $seasonId: ID!,
    $teamId: Int,
    $contextSeasonId: ID!,
  ) {
    copyMember(
      organizationId: $organizationId,
      seasonId: $seasonId,
      memberParticipantInfo: {
        divisionId: $divisionId,
        memberId: $memberId,
        teamId: $teamId,
        isManager: $isManager,
        isPlayer: $isPlayer
      }
    ) {
      id
      firstName
      lastName
      birthdate
      gender
      organizationId
      insertedAt
      joinedAt
      emailAddresses {
        id
        email
      }
      addresses {
        line1
        line2
        city
        state
        postalCode
      }
      phoneNumbers {
        id
        number
      }
      seasonParticipants(filter: { isArchived: null, seasonId: $contextSeasonId }) {
        ${SEASON_PARTICIPANT_FIELDS}
      }
    }
  }
`;

export default MUTATION;
